import moment from "moment";

export default function formatAudioFileDuration(seconds) {
    if (seconds >= 60 * 60) {
        return moment.utc(seconds * 1000).format('HH:mm:ss')
    }
    return moment.utc(seconds * 1000).format('mm:ss')
}